import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const RIRDPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      
      <main className="flex-grow">
        {/* Hero Section */}
        <section className="relative py-10 bg-blue-800">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-2xl md:text-3xl font-bold text-white">Regional Institutes of Rural Development & Panchayat Raj - RIRD&PR</h1>
              <div className="h-0.5 w-16 bg-white mt-2 mb-4"></div>
            </div>
          </div>
        </section>
        
        {/* Description Section */}
        <section className="py-6 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto bg-blue-50 p-6 rounded-lg shadow-sm">
              <p className="text-gray-700 leading-relaxed">
                The Regional Institutes of Rural Development & Panchayat Raj at SathiyaVijayaNagaram in Tiruvannamalai district, 
                Krishnagiri in Krishnagiri district, Pattukottai, in Thanjavur district, Bhavanisagar in Erode district and 
                T.Kallupatty in Madurai district are entrusted with the task of imparting training. RIRD & PRs are headed by 
                Principals in the cadre of Additional Director/Joint Director of Rural Development and Panchayat Raj Department.
              </p>
            </div>
          </div>
        </section>
        
        {/* Institutes Table Section */}
        <section className="py-6 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto bg-white rounded-lg shadow-md overflow-hidden">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead>
                    <tr className="bg-blue-700 text-white">
                      <th scope="col" className="px-4 py-3 text-left text-sm font-medium">S.No</th>
                      <th scope="col" className="px-4 py-3 text-left text-sm font-medium">Name of the Institution</th>
                      <th scope="col" className="px-4 py-3 text-left text-sm font-medium">Name of the District</th>
                      <th scope="col" className="px-4 py-3 text-left text-sm font-medium">Name of the Districts Covered</th>
                      <th scope="col" className="px-4 py-3 text-left text-sm font-medium">Year of Establishment</th>
                      <th scope="col" className="px-4 py-3 text-left text-sm font-medium">Area of the Institution (in acres)</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    <tr className="bg-gray-100 hover:bg-blue-50 transition-colors">
                      <td className="px-4 py-3 text-sm text-gray-900">1.</td>
                      <td className="px-4 py-3 text-sm font-medium text-gray-900">S.V. Nagaram</td>
                      <td className="px-4 py-3 text-sm text-gray-900">Tiruvannamalai</td>
                      <td className="px-4 py-3 text-sm text-gray-900">Kancheepuram,Villupuram,Tiruvallur,Cuddalore and Tiruvannamalai</td>
                      <td className="px-4 py-3 text-sm text-gray-900">1956</td>
                      <td className="px-4 py-3 text-sm text-gray-900">34.59</td>
                    </tr>
                    <tr className="bg-green-50 hover:bg-green-100 transition-colors">
                      <td className="px-4 py-3 text-sm text-gray-900">2.</td>
                      <td className="px-4 py-3 text-sm font-medium text-gray-900">Krishnagiri Dam</td>
                      <td className="px-4 py-3 text-sm text-gray-900">Krishnagiri</td>
                      <td className="px-4 py-3 text-sm text-gray-900">Krishnagiri,Namakkal,Salem,Dharmapuri and Vellore</td>
                      <td className="px-4 py-3 text-sm text-gray-900">1958</td>
                      <td className="px-4 py-3 text-sm text-gray-900">55.05</td>
                    </tr>
                    <tr className="bg-red-50 hover:bg-red-100 transition-colors">
                      <td className="px-4 py-3 text-sm text-gray-900">3.</td>
                      <td className="px-4 py-3 text-sm font-medium text-gray-900">Pattukottai</td>
                      <td className="px-4 py-3 text-sm text-gray-900">Thanjavur</td>
                      <td className="px-4 py-3 text-sm text-gray-900">Thanjavur,Tiruvarur,Nagapattinam,Tiruchurapalli,Pudukottaiand and Sivagangai</td>
                      <td className="px-4 py-3 text-sm text-gray-900">1954</td>
                      <td className="px-4 py-3 text-sm text-gray-900">20.94</td>
                    </tr>
                    <tr className="bg-blue-50 hover:bg-blue-100 transition-colors">
                      <td className="px-4 py-3 text-sm text-gray-900">4.</td>
                      <td className="px-4 py-3 text-sm font-medium text-gray-900">BhavaniSagar</td>
                      <td className="px-4 py-3 text-sm text-gray-900">Erode</td>
                      <td className="px-4 py-3 text-sm text-gray-900">Erode,Coimbatore,Dindigul,The Nilgiris,Karur,Perambalur, Ariyalur and Tiruppur</td>
                      <td className="px-4 py-3 text-sm text-gray-900">1972</td>
                      <td className="px-4 py-3 text-sm text-gray-900">71.89</td>
                    </tr>
                    <tr className="bg-yellow-50 hover:bg-yellow-100 transition-colors">
                      <td className="px-4 py-3 text-sm text-gray-900">5.</td>
                      <td className="px-4 py-3 text-sm font-medium text-gray-900">T Kallupatti</td>
                      <td className="px-4 py-3 text-sm text-gray-900">Madurai</td>
                      <td className="px-4 py-3 text-sm text-gray-900">Madurai,Theni,Virudhunagar,Ramnad, Tirunelveli,Thoothukudi and Kanniyakumari</td>
                      <td className="px-4 py-3 text-sm text-gray-900">1948</td>
                      <td className="px-4 py-3 text-sm text-gray-900">49.00</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </main>
      
      <Footer />
    </div>
  );
};

export default RIRDPage;